import { Component, OnInit } from '@angular/core';
import {ServerConstantsService} from '../serverConstants.service'
import { Router,RouterModule, NavigationEnd,NavigationStart} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public buildConstants:any;
  public baseLine:any;
  public faq:Boolean = false;

  constructor(public serverConstantsService: ServerConstantsService, public router:Router) {
    this.buildConstants = serverConstantsService.getBuildConstants();
   }

  ngOnInit() {
    if(this.buildConstants != undefined && this.buildConstants.BUILD_NUMBER != undefined && this.buildConstants.BUILD_TIME != undefined) {
      this.baseLine = this.buildConstants.BUILD_NUMBER + '  :  ' + this.buildConstants.BUILD_TIME;
      if(sessionStorage.getItem('id') != null && sessionStorage.getItem('id') != undefined){
        this.faq = true;
      }
    }    
  }
  navigate(){
    this.router.navigate(['faqs']);
  }
  close(){
    if(document.getElementById("popup1") != null){
      document.getElementById("popup1").classList.add("remove");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts